var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11467_239041",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11467_239041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16.998H13C13.2833 16.998 13.521 16.902 13.713 16.71C13.9043 16.5187 14 16.2814 14 15.998C14 15.7147 13.9043 15.477 13.713 15.285C13.521 15.0937 13.2833 14.998 13 14.998H8C7.71667 14.998 7.479 15.0937 7.287 15.285C7.09567 15.477 7 15.7147 7 15.998C7 16.2814 7.09567 16.5187 7.287 16.71C7.479 16.902 7.71667 16.998 8 16.998ZM8 12.998H16C16.2833 12.998 16.5207 12.902 16.712 12.71C16.904 12.5187 17 12.2814 17 11.998C17 11.7147 16.904 11.477 16.712 11.285C16.5207 11.0937 16.2833 10.998 16 10.998H8C7.71667 10.998 7.479 11.0937 7.287 11.285C7.09567 11.477 7 11.7147 7 11.998C7 12.2814 7.09567 12.5187 7.287 12.71C7.479 12.902 7.71667 12.998 8 12.998ZM8 8.99805H16C16.2833 8.99805 16.5207 8.90205 16.712 8.71005C16.904 8.51871 17 8.28138 17 7.99805C17 7.71471 16.904 7.47705 16.712 7.28505C16.5207 7.09371 16.2833 6.99805 16 6.99805H8C7.71667 6.99805 7.479 7.09371 7.287 7.28505C7.09567 7.47705 7 7.71471 7 7.99805C7 8.28138 7.09567 8.51871 7.287 8.71005C7.479 8.90205 7.71667 8.99805 8 8.99805ZM5 18.998H19V4.99805H5V18.998ZM5 20.998C4.45 20.998 3.979 20.8024 3.587 20.411C3.19567 20.019 3 19.548 3 18.998V4.99805C3 4.44805 3.19567 3.97705 3.587 3.58505C3.979 3.19371 4.45 2.99805 5 2.99805H9.2C9.41667 2.39805 9.77933 1.91471 10.288 1.54805C10.796 1.18138 11.3667 0.998047 12 0.998047C12.6333 0.998047 13.2043 1.18138 13.713 1.54805C14.221 1.91471 14.5833 2.39805 14.8 2.99805H19C19.55 2.99805 20.021 3.19371 20.413 3.58505C20.8043 3.97705 21 4.44805 21 4.99805V18.998C21 19.548 20.8043 20.019 20.413 20.411C20.021 20.8024 19.55 20.998 19 20.998H5ZM12 4.24805C12.2167 4.24805 12.396 4.17705 12.538 4.03505C12.6793 3.89371 12.75 3.71471 12.75 3.49805C12.75 3.28138 12.6793 3.10205 12.538 2.96005C12.396 2.81871 12.2167 2.74805 12 2.74805C11.7833 2.74805 11.6043 2.81871 11.463 2.96005C11.321 3.10205 11.25 3.28138 11.25 3.49805C11.25 3.71471 11.321 3.89371 11.463 4.03505C11.6043 4.17705 11.7833 4.24805 12 4.24805Z",
    fill: "#00B0CA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/Assignment.70de8ef2c3f2c11e38dfa5872ae413a5.svg";
export { ForwardRef as ReactComponent };